import React, { useEffect, useRef, useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';

type IntervalFunction = () => unknown | void;

function useInterval(callback: IntervalFunction, delay: number | null) {
  const savedCallback = useRef<IntervalFunction | null>(null);

  useEffect(() => {
    if (delay === null) return;
    savedCallback.current = callback;
  });

  useEffect(() => {
    if (delay === null) return;
    function tick() {
      if (savedCallback.current !== null) {
        savedCallback.current();
      }
    }
    const id = setInterval(tick, delay);
    return () => clearInterval(id);
  }, [delay]);
}

// eslint-disable-next-line @typescript-eslint/ban-types
export default function Clock(): JSX.Element {
  const [time, setTime] = useState<Dayjs>(dayjs());

  useInterval(() => {
    setTime(dayjs());
  }, 1000);

  return (
    <span className="navbar__clock-text">
      <span>{time.format('HH:mm:ss')}</span>
      {' | '}
      <span>
        {time.format('DD.MM')} W{time.isoWeek()}
      </span>
    </span>
  );
}
